import requestUtils from "../request_util";
import store from "@/store";
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '../constant.js';
export default {
  retryTime:0,
  cancelGdData(ud, type, gd, wd) {
    this.ud = ud;
    this.type = type;
    this.gd = gd;
    this.wd = wd;
  },
  cancelIdData(ud, type, id, wd) {
    this.ud = ud;
    this.type = type;
    this.id = id;
    this.wd = wd;
  },
  taskListData(ud, type) {
    this.ud = ud;
    this.type = type;
  },
  torrentListData(ud) {
    this.ud = ud;
  },
  getTasks(ud, type, id, gd) {
    if (gd) {
      this.ud = ud;
      this.type = type;
      this.gd = gd;
    }
    if (id && !gd) {
      this.ud = ud;
      this.type = type;
      this.id = id;
    }
  },
  executeData(ud, type, id, gd) {
    if (gd) {
      this.ud = ud;
      this.type = type;
      this.gd = gd;
    }
    if (id && !gd) {
      this.ud = ud;
      this.type = type;
      this.id = id;
    }
  },
  updateIdData(id, ud, type, n, options, schedules) {
    this.id = id;
    this.ud = ud;
    this.type = type;
    this.n = n;
    if(options){
    this.options = options;
    }
    if(schedules){
    this.schedules = schedules;
    }
  },
  updateGdData(gd, ud, type, n, options, schedules) {
    this.gd = gd;
    this.ud = ud;
    this.type = type;
    this.n = n;
    if(options){
    this.options = options;
    }
    if(schedules){
    this.schedules = schedules;
    }
  },
  progressData(ud, type, id, wd,gd) {
    this.ud = ud;
    this.type = type;
    this.id = id;
    if (wd) {
      this.wd = wd;
    }
    if(gd){
        this.gd=gd;
    }
  },
  deleteTaskData(ud, type, id, gd) {
    if (gd) {
      this.ud = ud;
      this.type = type;
      this.gd = gd;
    }
    if (id && !gd) {
      this.ud = ud;
      this.type = type;
      this.id = id;
    }
  },
  executeRestoreData(ud,type,id,tw,vd,toItems,restoreItems,options){
      this.ud=ud;
      this.type=type;
      this.id=id;
      this.tw=tw;
      this.vd=vd;
      if(toItems){
      this.toItems=toItems;
      }
      this.restoreItems=restoreItems;
      this.options=options;
  },
  deleteVersionDate(ud,id,vd,type,dvf){
    this.ud=ud;
    this.id=id;
    this.vd=vd;
    this.type=type;
    this.dvf=dvf;
  },
  inintTaskList(callback) {
    //初始化任务列表数据
    let that = this;
    if (flag) {//如果此时没有其他接口在请求数据，则进入该方法
      flag = false;
      store.state.taskListNotGropArrCopy = [];//让缓存数据为空
      that.taskListRequest({ud:commonUtils.getUser().id,type:2},function(res1) {//获取同步任务
              //必须同步加载，防止数据重复并防止闪烁
              flag = true;
              let allNotGropArr = store.state.taskListNotGropArrCopy;//把返回数据存入缓存
              store.commit("setTaskListNotGropArr", allNotGropArr);
              callback(res1);
        },error => {
            flag = true;
            callback(error);
          });
    } else {
      callback("fail");
    }
  },
  sortCreateTime(a, b) {
    if (a && b) return -(a.createTime - b.createTime);
  },
  // 更新用户好评相关信息
  userStarUpdateRequest(data){
    let user = commonUtils.getUser();
    data.ud = user.id;
    requestUtils.doUserStarRequest("update",data).then(res => {
      console.log(res);
    });
  },
  // 是否要显示用户好评弹窗
  canShowUserStarRequest(now, callback){
    let user = commonUtils.getUser();
    requestUtils.doUserStarRequest("check_pop",{ud:user.id, salt:user.salt}).then(res => {
      callback(now, res);
    });
  },
  taskListRequest(taskListData, callback) {
    //获取后端返回的数据
    let that = this;
    requestUtils.doTasksRequest("all_list", taskListData).then(
      res => {
        //报错则终止
        if(res.status == 400){
          callback(res);
          return;
        }
       // if (res[2] && res[2].status == 200) {
            //每请求一次把数据放在taskListNotGropArrCopy中
            let originArr = store.state.taskListNotGropArrCopy;
            let businessTasks = res[0].tasks;
            let transferTasks = res[1].tasks;
            let backupTasks = res[2].tasks;
            let realTimeTasks = res[3].tasks;
            let syncTasks = res[4].tasks;
            // for(let i=0;i<transferTasks.length;i++){
            //   if(transferTasks[i].options.way=="cloudEmail"){
            //     transferTasks[i].branchType = 'cloudEmail';
            //   }
            // }
            for(let k=0;k<businessTasks.length;k++){
                var dataBusiness= businessTasks[k].businessTask;
                if(dataBusiness.status=='Waiting'||dataBusiness.status=='Running'){
                    delete dataBusiness.result;
                }
                dataBusiness.sources = businessTasks[k].transferTasks;
                dataBusiness.type=1;
                if(businessTasks[k].transferTasks[0]){
                dataBusiness.fromItem =  businessTasks[k].transferTasks[0].fromItem;
                }
                if(businessTasks[k].transferTasks[0]){
                dataBusiness.toItem =  businessTasks[k].transferTasks[0].toItem;
                }
                dataBusiness.branchType='businessTransfer';
                businessTasks[k]=dataBusiness;
            }
            for(let i=0;i<realTimeTasks.length;i++){
                realTimeTasks[i].branchType = 'realtime';
                for(let j=0;j<syncTasks.length;j++){
                    if(syncTasks[j].id==realTimeTasks[i].id){
                        syncTasks.splice(j,1);
                        j--; 
                    }
                }
            }
            for(let j=0;j<backupTasks.length;j++){
                backupTasks[j].type = 6;
            }
            let allNotGropArr = ((originArr.concat(transferTasks)).concat(realTimeTasks)).concat(syncTasks).concat(backupTasks).concat(businessTasks);
            store.state.taskListNotGropArrCopy = allNotGropArr;
            // 是否开启用户好评弹窗
            store.state.isShowUserStar = true;
            // console.log(allNotGropArr);
        //}
        callback(res);
      },
      err => {
        setTimeout(()=>{
        delete taskListData.s;
        that.retryTime = that.retryTime+1;
        if( that.retryTime <= 6){
           that.taskListRequest(taskListData, callback);//如果后端报错，则重试请求
        }
      },200);
      }
    );
  },
  realtimeListRequest(listData,callback){
    requestUtils.doRealtimeSyncRequest("list",listData).then(
        res=>{
            if (res.message == 'success') {
                if (res.data.length) {
                  //每请求一次把数据放在taskListNotGropArrCopy中
                  let originArr = store.state.taskListNotGropArrCopy;
                  let allNotGropArr = originArr.concat(res.data);
                  store.state.taskListNotGropArrCopy = allNotGropArr;
                }
              }
              callback(res);
    });

  },
  //判断是否过时
  judgeOutdated(item) {
    let value = item.schedules;
    let onceTime = value.date + " " + value.times[0];
    var nextTimeLong = new Date(
      onceTime.replace(new RegExp("-", "gm"), "/")
    ).getTime();
    let nowTimeLong = new Date().getTime();
    if (nowTimeLong > nextTimeLong) {
      item.schedules.outDate = true; //判断时间是否过时，过时则显示Scheduled
    }
    return item;
  },
  //把返回的list散装数据封装成groupId为一组的数据
  constructGroupData(resTask) {
    var resTaskOrigin = Object.assign([], resTask);
    //循环比较
    for (let j = 0; j < resTaskOrigin.length; j++) {
      let k = j + 1;
      //若两条数据id不等但是groupId相等
      if (resTaskOrigin[j] &&resTaskOrigin[k] &&resTaskOrigin[k].id &&resTaskOrigin[j].groupId &&resTaskOrigin[k].groupId &&resTaskOrigin[j].groupId == resTaskOrigin[k].groupId) {
        if (!resTaskOrigin[j].sources) {
            resTaskOrigin[j].sources = [];//新增sources字段
        }
          //将该条新增的数据放入sources数组中
          resTaskOrigin[j].sources.push(resTaskOrigin[k]);
          //在源数组中删除groupId一致已加入sources的项
          resTaskOrigin.splice(k, 1);
          j--;
        
      }
    }
    return resTaskOrigin;
  },
  exeCuteFlowIcon(idFlow, idFix, direction) {
    let dom;
    let that = this;
    let taskRedMark = document.getElementById("listRedMark0");
    direction.flowShow = true;
    direction.$nextTick(function() {
      that.flowIcon(idFlow, idFix);
    });
    taskRedMark.style.display = "block";
    $.each(direction.$parent.$children, function(i, item) {
      if (item.menuOptions) {
        //如果是left_banner组件
        dom = direction.$parent.$children[i];
        return;
      }
    });
    dom.taskListNumber = dom.taskListNumber + 1;
    setTimeout(() => {
      direction.flowShow = false;
    }, 1300);
  },
  //添加任务成功后，图标漂浮到固定的一个图标的地方
  flowIcon(idFlow, idFix) {
    //获取要漂浮图标的id
    let flowIcon = document.getElementById(idFlow);
    //获取目的地图标的id
    let taskListIcon = document.getElementById(idFix);
    //获取要漂浮的距离
    let xPx =
      taskListIcon.getBoundingClientRect().left -
      flowIcon.getBoundingClientRect().left;
    let yPx =
      taskListIcon.getBoundingClientRect().bottom -
      flowIcon.getBoundingClientRect().bottom;
    //给一个动画效果
    flowIcon.style.transition = "all 1.4s ease";
    flowIcon.style.transform =
      "translate3d(" + xPx + "px, " + yPx + "px, 0px) scale(1.2) scale(1)";
    setTimeout(() => {
      //延迟两秒后消失
      flowIcon.style.transition = "none";
      flowIcon.style.transform = "translateX(1px)";
      flowIcon.style.opacit = "0";
    }, 2000);
  },
  //添加传输同步任务成功
  exeSuccessEnd(idFlow, idFix, tasks, diction) {
    let that = this;
    //把新增的数据存入未分组的数组便于计数
    let originArr = Object.assign([], store.state.taskListNotGropArr);
    if(!tasks){
        tasks=[];
    }
    let allNotGropArr = tasks.concat(originArr);
    store.commit("setTaskListNotGropArr", allNotGropArr);
    that.addLength(diction);
    that.exeCuteFlowIcon(idFlow, idFix, diction);
    //只要执行了这个方法说明就产生了新的任务，将缓存中是否有新任务标志置为真
    store.state.newTaskflag=true;
    store.state.initProgressFlag=false;
    diction.clearPageChoose();
    diction.loading = false;
  },
  //默认任务名增加长度
  addLength(diction) {
    diction.allLength = diction.allLength + 1;
    diction.inputValue = "Task " + diction.allLength;
    diction.$refs.editInput.value = diction.inputValue;
  },
  //删除任务
  deleteTask(deleteItem, deleteIndex) {
    let deleteData;
    let that=this;
    if (deleteItem.groupId) {
      deleteData = new this.deleteTaskData(commonUtils.getUser().id,deleteItem.type,null,deleteItem.groupId);
    } else {
      deleteData = new this.deleteTaskData( commonUtils.getUser().id, deleteItem.type, deleteItem.id, null);
    }
    if(deleteItem.branchType=='realtime'){
        requestUtils.doRealtimeSyncRequest("cancel", deleteData).then(res => {
            if (res.message == 'success') {//如果删除成功
              that.deleteTaskSuccess(deleteItem,deleteData);
            }else if((deleteData.type==2 || deleteData.type==6)&&res.msg.trim()=='The task not found'){//如果删除成功并且类型是同步
              that.deleteTaskSuccess(deleteItem,deleteData);
            }
          });
    }else{
        if(deleteItem.branchType == 'businessTransfer'){
            deleteData={
                id: deleteItem.id,
                ud:commonUtils.getUser().id
            }
            requestUtils.doBusinessTransferRequest("delete",deleteData).then(res => {
                 that.deleteTaskSuccess(deleteItem,deleteData);
            }).catch(err =>{
			})
            return;
        }
    requestUtils.doTasksRequest("delete", deleteData).then(res => {
      if (res.status == 200) {//如果删除成功
        that.deleteTaskSuccess(deleteItem,deleteData);
      }else if((deleteData.type==2 || deleteData.type==6)&&res.msg.trim()=='The task not found'){//如果删除成功并且类型是同步
        that.deleteTaskSuccess(deleteItem,deleteData);
      }
    });
  }
  },
  deleteTaskSuccess(deleteItem,deleteData){
    let allGroupArr = Object.assign([], store.state.taskListNotGropArr);
        if (deleteItem.groupId) {
          store.state.taskListNotGropArr = allGroupArr.filter(item => {
            return item.groupId != deleteData.gd;
          });
        } else {
          store.state.taskListNotGropArr = allGroupArr.filter(item => {
            return item.id != deleteData.id;
          });
        }
        if (!store.state.taskListNotGropArr.length) {
          store.commit("setTaskListArrAll", []);
        }
  },//如果含有任务则进行删除
  delteHavaTask(cloudId) {
    let that = this;
    let allTasklistData = Object.assign([], store.state.taskListArr);
    $.each(allTasklistData, function(index, data) {
      if (!data.sources) {
        if ((data.fromItem.driveId == cloudId ||data.toItem.driveId == cloudId)) {
          that.deleteTask(data, index);
        }
      } else if (data.sources) {
        $.each(data.sources, function(m, item) {
          if ((data.fromItem.driveId == cloudId ||data.toItem.driveId == cloudId ||item.fromItem.driveId == cloudId ||item.toItem.driveId == cloudId
          )) {
            that.deleteTask(data, index);
          }
        });
      }
    });
  },
  showStatus(item){
    let result;
    if(item.type!=2){
    if(item.lastLog&&item.lastLog.response=='success'&&!item.lastLog.errorList.length &&item.result &&item.result.toLowerCase()!='cancel'){
        result='success';
        return result;
    }
    if((item.result&&item.lastLog&&item.lastLog.response!='cancel'&&item.result.toLowerCase()=='cancel')||(item.lastLog&&item.lastLog.response=='cancel')||(item.result&&item.result.toLowerCase()=='cancel'&&!item.lastLog)||(item.resul&&item.result.toLowerCase()=='cancel'&&item.lastLog&&!item.lastLog.errorList.length&&item.lastLog.response=='error')){
         result='cancel';
          return result;
    }
    if(item.lastLog &&item.result  && item.result.toLowerCase()!='cancel'&&item.lastLog &&item.lastLog.response!='cancel' && item.lastLog.errorList.length > 0&&((item.lastLog.errorList.length/item.lastLog.totalFileCount)*100<20)){
        result='partialSuccess';
    }else{
        result='failure';
    }
    if(item.tranferWay=="backup" && item.lastLog.response != 'success'){
      if(item.result  && item.result.toLowerCase()!='cancel'&&item.lastLog &&item.lastLog.response!='cancel' && (item.lastLog.readyTranFileCount/item.lastLog.totalFileCount*100>80)){
        result='partialSuccess';
      }else{
        result='failure';
      }
    }
    return result;
   }
   if(!item.lastLog){
    return;
   }
   var lastLog = item.lastLog.newLog[0];
   if(lastLog&&lastLog.response=='success'&&!lastLog.errorList.length &&item.result &&item.result.toLowerCase()!='cancel'){
    result='success';
    return result;
}
if((item.result&&lastLog&&lastLog.response!='cancel'&&item.result.toLowerCase()=='cancel')||(lastLog&&lastLog.response=='cancel')||(item.result&&item.result.toLowerCase()=='cancel'&&!lastLog)||(item.resul&&item.result.toLowerCase()=='cancel'&&lastLog&&!lastLog.errorList.length&&lastLog.response=='error')){
     result='cancel';
      return result;
}
if(lastLog &&item.result  && item.result.toLowerCase()!='cancel'&&lastLog &&lastLog.response!='cancel' && lastLog.errorList.length > 0&&((lastLog.errorList.length/lastLog.totalFileCount)*100<20)){
    result='partialSuccess';
}else{
    result='failure';
}
    return result;
},
  //显示取消状态
  showCancelStatus (item) {
    let flag;
    let resultArr = [];
    let cancelStatusArr = [];
    let that = this;
    //如果任务未结束则直接返回
    if (!this.judgeTaskEnd(item)) {
      return false;
    }
    //如果是单目标或者单源的任务
    if (!item.sources) {
      if (item.result && (item.result.toLowerCase() == 'cancel' || item.status.toLowerCase() == 'canceled') ) {
        flag = true;
      }
      if (item.type==6 && ((item.result &&item.result.toLowerCase() == 'cancel') || item.status.toLowerCase() == 'canceled') ) {
        flag = true;
      }
    } else { //如果是多目标或者多源的 如果所有的目标都是取消则显示取消 若有其他状态则显示其他状态对应的情况，不显示取消
      if (item.result) {
        if (item.status == 'Canceled') {
          item.result = 'cancel';
        }
        resultArr.push(item.result.toLowerCase());
      }
      $.each(item.sources, function (i, sourceItem) {
          //如果任务已经运行结束则加入数组
        if (sourceItem.result && sourceItem.status != 'Waiting' && sourceItem.status != 'Running' && that.judgeTaskEnd(sourceItem)) {
          resultArr.push(sourceItem.result.toLowerCase());
        }
      });
      $.each(resultArr, function (j, jItem) {
        if (jItem == 'cancel') {
          cancelStatusArr.push(jItem);
        }
      });
      //如果多为取消任务状态，则显示为取消状态,如果取消的概率大于0
      if (cancelStatusArr.length > 0 && (item.status == 'Done' || item.status == 'Canceled' || item.status == 'Normal')) {
        flag = true;
      }
    }
    return flag;
  },
   //显示单个或多个传输任务的运行状态
  showTransferRunning (item) {
        let flag;
        if(item.sources){
            if(item.type=='businessTransfer'&&item.status=='Running'){
                return true;
            }
          if ( item.status != 'Done' && item.type == 1 && (item.percent ||(item.transferDetail && item.transferDetail.state2 && item.status != 'Waiting' && item.transferDetail.state2.status != 1 && item.transferDetail.state2.totalFileCount > 0 && !item.result))) {
               flag = true;
             }
        }else{
          if ( item.status != 'Done' && item.type == 1 && item.transferDetail && item.transferDetail.state2&& item.transferDetail.state2.status != 0 && item.transferDetail.state2.status != 1 && item.transferDetail.state2.totalFileCount > 0 && !item.result) {
              flag = true;
            }
        }
        return flag;
      },
   //显示单个备份进度的运行状态
   showBackupRunning(item){
    let flag;
    if(item.sources){
      if ( item.status != 'Done' && item.type == 6 && (item.percent ||(item.transferDetail && item.transferDetail.state2 && item.status != 'Waiting' && item.transferDetail.state2.status != 1 && item.transferDetail.state2.totalFileCount > 0 && !item.result))) {
           flag = true;
         }
    }else{
      if ( item.status != 'Done' && item.type == 6 && (item.status=='Running' || item.status=='Restoring')) {
          flag = true;
        }
    }
    return flag;
   },
   showBackupWaiting(item){
    let flag;
    if ( item.status != 'Done' && item.type == 6 && item.status=='Waiting' && item.status != 'Running') {
        flag = true;
      }
    return flag;
   },
    //显示单个同步任务的运行状态
    showSyncSingleRunning (item) {
        let flag;
        // if(item.type == 1 && item.branchType=='businessTransfer'){
        //   flag = true;
        // }
        if (!item.sources  && item.type == 2 && (item.status != 'Waiting' || item.percent) && item.syncDetail && (item.syncDetail.runningStatus > 1)) {
          flag = true;
        }
        if(!item.sources && item.type==2 && item.branchType=='realtime' && (item.status=='Run'||item.status=='Init')){
            flag=true;
        }
        return flag;
        },
        //显示多目标同步任务的正在运行状态
    showSyncSourceRunning (item) {
      let flag;
      let that = this;
      //2成功 1部分成功 0失败
      if(item.type == 2 && item.sources && this.testSources(item) != 2){
         if (!this.judgeTaskEnd(item)  && item.status != 'Done' && item.avgpercent && item.avgpercent != '0' && item.avgpercent != 100) {
             flag = true;
             return flag;
            }
        if ((item.status == "Running" || item.percent) && item.avgpercent != 100 && !this.judgeTaskEnd(item)) {
             flag = true;
             return flag;
        }
        for (let sIndex = 0; sIndex <= item.sources.length - 1; sIndex++) {
          let sItem = item.sources[sIndex];
          if ((((sItem.status == "Running" || sItem.status == "Waiting" )&& sItem.percent!=100) || (sItem.percent && !sItem.result)) && item.avgpercent != 100 && !that.judgeTaskEnd(sItem)) {
            flag = true;
            return flag;
          }
        }
      }
      if(item.type == 2 && item.sources && (item.status=='Run'||item.status=='Init')){
        flag = true;
      }
      return flag;
    },
       //显示单个同步任务的等待状态
       showSyncSingleWaiting (item) {
        let flag;
        if(item.type == 2 && !item.sources){
           if ( ((item.syncDetail && item.status != 'Done' && item.syncDetail.runningStatus == 0) || (!item.percent && item.status == 'Waiting') ||(item.status == 'Running' && !item.syncDetail) )) {
               flag = true;
            }
        }
        return flag;
      },
      //显示单个或多个传输任务的等待状态
      showTransferWaiting (item) {
        let flag;
        let that = this;
        if ((item.type == 1 && item.status != 'Done'  && !item.percent && !item.speed && ((item.transferDetail && item.transferDetail.state2 && (item.transferDetail.state2.status == 0 || item.transferDetail.state2.totalFileCount == 0)) || (item.status == 'Waiting' && !item.result && !item.percent) || (item.status == 'Running' && !item.transferDetail && !item.result)))) {
          flag = true;
        }
        if(item.type == 1 && item.status == "Waiting"){
          flag = true;
        }
        if (item.type == 1 && item.sources) {
            if(item.branchType == 'businessTransfer'){
               if(item.status=='Done'){
                   flag = false;
                   return flag;
               }
            }
          $.each(item.sources, function (j, jItem) {
            if ((jItem.status != 'Done' && !item.cancelStatus && !item.percent && !jItem.cancelStatus && !jItem.percent && !jItem.speed && ((jItem.transferDetail && jItem.transferDetail.state2 && jItem.transferDetail.state2.status == 0) || (jItem.status == 'Waiting') || (jItem.status == 'Running' && !jItem.transferDetail && !jItem.result)))) {
              flag = true;
            }
          });
        }
        return flag;
      },
             //显示多目标任务的准备状态
    showSyncSourceWaiting (item) {
        let flag;
        //如果该任务在正在运行中并还没计算出平均进度则显示准备状态
        if (item.type == 2 && (item.avgpercent == 0 || !item.avgpercent) && item.sources && !item.result && item.status != "Normal") {
          flag = true;
          if (item.status == "Running") { //如果该任务在运行状态则显示运行状态
            flag = false;
            return;
          } else if (item.status == "Waiting" || (item.syncDetail && item.syncDetail.runningStatus == 0)) {//如果该任务在等待状态则显示等待状态
            flag = true;
          }
          $.each(item.sources, function (sIndex, sItem) {
            if (sItem.status != "Waiting" ) {
              flag = false;
              return;
            } else if (sItem.status == "Waiting" || (sItem.syncDetail && sItem.syncDetail.runningStatus == 0)) {
              flag = true;
            }
          });
        }
        return flag;
      },
        //显示失败状态的任务
    showFailStatus (item) {
      let flag = false;
      if (!item.errorFileCount && item.transferDetail  && item.transferDetail.state2 && item.transferDetail.state2.errorList && item.transferDetail.state2.errorList.length) {
        item.errorFileCount = item.transferDetail.state2.errorList.length;
        }
        //如果是云备份任务
        if (!item.errorFileCount && item.transferDetail  && item.transferDetail.errorList && item.transferDetail.errorList.length) {
            item.errorFileCount = item.transferDetail.errorList.length;
          }
          if (!item.viewed && item.result && item.result != "cancel" && (
          ((item.errorFileCount / item.totalFileCount) * 100 > 20) && item
            .status != 'Running')) {
              flag = true;
        }
        if (!item.viewed && item.result && item.result == "error" && (item.errorFileCount == 1 && item.status != 'Running')) {
          flag = true;
        }
        if (!item.viewed && item.result && item.result == "error" &&!item.errorFileCount && item.type==2 && item.status != 'Running') {
            flag = true;
          }
        
          if (!item.viewed && item.type==6 && item.lastLog &&item.result == 'error'  && item.status != 'Running' && (item.lastLog.totalFileCount == 0 || ((item.lastLog.readyTranFileCount / item.lastLog.totalFileCount) * 100 < 80))) {
            flag = true;
          }
        if(!item.viewed && item.type==1 && item.lastLog && item.result == 'error'  && item.result.toLowerCase()!='cancel' &&item.lastLog.response!='cancel' &&(item.lastLog.totalFileCount == 0 || (item.lastLog.errorList.length/item.lastLog.totalFileCount)*100<20)){
          flag=true;
        }
        return flag;
      },
       //显示部分成功状态
    showpartialStatus (item) {
      let flag = false;
      if (!item.errorFileCount) {
        item.errorFileCount = 0;
      }
      if(item.type == 6){
          if(item.lastLog && item.lastLog.readyTranFileCount){
              item.readyTranFileCount = item.lastLog.readyTranFileCount;
          }
          if(item.lastLog && item.lastLog.totalFileCount){
            item.totalFileCount = item.lastLog.totalFileCount;
        }
        if (item.result != "cancel" && item.readyTranFileCount 
        && (100 > ((item.readyTranFileCount / item.totalFileCount) * 100) && ((item.readyTranFileCount / item.totalFileCount) * 100 >= 80) 
        && item.readyTranFileCount > 0 && item.status != 'Running')) {
          flag = true;
        }
      }else{
        if (item.result != "cancel" && item.errorFileCount != 1 && ((item.errorFileCount / item.totalFileCount) * 100 <= 20 && item.errorFileCount && item
          .status != 'Running')) {
          flag = true;
        }
      }
      return flag;
    },
       //单源传输单目标同步任务成功
    showSuccessStatus (item) {
      if(item.branchType=='businessTransfer'&&item.status=='Done'&&item.result == 'success'){
        flag = true;
        return flag;
      }
      if (!this.judgeTaskEnd(item) || item.branchType=='realtime') {
        return false;
      }
      let flag = false;
      //如果不是定时任务
      if (!item.schedules) {
        if (item.result == 'success' || (item.type == 1 && item.percent == 100  && item.transferDetail && item.transferDetail.state2 && !item.transferDetail.state2.errorList.length)) {
          item.result = 'success';//如果检测到进度为100，立马让任务在界面显示成功
          item.status = 'Done';
          flag = true;
        }
      } else {
        if (item.result == 'success' || (item.type == 1 && item.percent == 100 )) {
          item.result = 'success';//如果检测到进度为100，立马让任务在界面显示成功
          item.status = 'Done';
          flag = true;

        }
      }
      //如果是定时任务
      return flag;
    },
    // 传输多源 同步多目标任务传输失败
    showSourcesFailureStatus (item) {
        let that = this;
        let flag;
        if(item.branchType !='businessTransfer'){
        if (!this.judgeTaskEnd(item)) {
            return false;
          }
       }
        //用于判断多源
        if (!item.viewed  && this.testSources(item) == 0 && item.status != 'Running' && item.status !=
          'Waiting') {
           flag = true;
          $.each(item.sources, function (i, sourceItem) {
            if (!sourceItem.result && that.judgeTaskEnd(sourceItem)) {
              flag = false;
              return;
            }
          });
        }
        return flag;
      },
    // 显示筛选状态传输多源 同步多目标任务传输失败
    showSwitchSourcesFailureStatus (item) {
        let that = this;
        let flag;
        if (!this.judgeTaskEnd(item)) {
          return false;
        }
        //用于判断多源
        if ( this.testSources(item) == 0 && item.status != 'Running' && item.status !=
          'Waiting') {
           flag = true;
          $.each(item.sources, function (i, sourceItem) {
            if (!sourceItem.result && that.judgeTaskEnd(sourceItem)) {
              flag = false;
              return;
            }
          });
        }
        return flag;
      },
     //显示多源多目标的部分成功状态
     showSourcepartialStatus (item) {
        let flag;
        let that = this;
        if (!this.judgeTaskEnd(item)) {
          return false;
        }
        if (item.sources && this.testSources(item) == 1) {
          if (item.status == 'Done' || item.result == 'success') {
            flag = true;
          }
          if (item.status == 'Running' || item.status == 'Waiting') {
            flag = false;
          } else {
            $.each(item.sources, function (i, sourceItem) {
              if (sourceItem.result == 'success' && that.judgeTaskEnd(sourceItem)) {
                flag = true;
              }
              if (sourceItem.status == 'Running' || sourceItem.status == 'Waiting') {
                flag = false;
              }
            });
          }
        }
        return flag;
      },
        //显示传输多源或同步多目标任务成功
    showSourceSuccessStatus (item) {
      let that = this;
      let flag;
      if(item.branchType!='businessTransfer'){
      if (!this.judgeTaskEnd(item)) {
        return false;
      }
     }else{
         if(item.status=='Done'&&item.result=='success'){
             return true;
         }
     }
      if ((item.sources && this.testSources(item) == 2 && item.result == 'success' && item.status != 'Running')||(item.branchType=='businessTransfer'&& this.testSources(item) == 2&& item.status != 'Running')) {
        item.result = 'success';
        item.status = 'Done';
        $.each(item.sources, function (j, jItem) {
          jItem.result = 'success';
          jItem.status = 'Done';
        });
        if (item.avgpercent) {
          item.avgpercent = 100;
        }
        flag = true;
      }
      if (item.sources && item.type == 2 && item.avgpercent == 100) {
        delete item.avgpercent;
        flag = true;
      }
      return flag;
    },
    judgeTaskEnd (item) {
        let flag = true;
        if (item.type == 1 && item.branchType!='businessTransfer') { //判断传输任务是否结束,如果没有结束该方法返回false
          if (item.transferDetail && item.transferDetail.state2.response) {
            if (!isNaN(item.transferDetail.state2.response)) {//如果没有完成该方法返回false
              flag = false;
              return flag;
            }
          }
          if (item.status == 'Running' || item.status == 'Waiting') {
            flag = false;
            return flag;
          }
        } else {
          if (item.syncDetail && item.syncDetail.response) {
            if (!isNaN(item.syncDetail.response)) {
              flag = false;
              return flag;
            } else {
              return true;
            }
          }
          if (item.status == 'Running' || item.status == 'Waiting') {
            flag = false;
            return flag;
          }
        }
        return flag;
      },
     //收拢已经成功的界面
     originalPage (index,direction) {
        if (direction.$parent.collapseFlage == index) {
          if (direction.$refs.threadParents) {
            direction.$refs.threadParents.style.height = 95 + 'Px';
            direction.$refs.threadParents.parentElement.parentElement.style.height = 95 + 'Px';
          }
          direction.$parent.collapseFlage = -1;
        }
      },
    //判断多源和多目标的任务错误列表是否超过了20%，如果是则显示错误，不是则显示部分成功
    testSources (itemData) {
    let flag; //2成功 1部分成功 0失败 3取消
    let allResult = [];//所有任务结果数组
    let failArr = [];//失败任务数组
    let cancelArr = [];//取消状态的数组
    let successArr = [];//成功数组
    let allExCancelArr = [];//不包含取消的所有任务
    let AllSources = Object.assign([], itemData.sources);
    if(itemData.branchType!="businessTransfer"){
    AllSources.push(itemData);
    }
    let that = this;
    $.each(AllSources, function (i, item) {
      if (item.status == "Running" || item.status == 'Waiting') {
        failArr = [];
        return false;
      }
      allResult.push(item.result);
      if ((item.result == 'error')) {
        failArr.push(item);
      }
      if ((item.result == 'success')) {
        successArr.push(item);
      }
      if (item.result && (item.result.toLowerCase() == 'cancel' || item.status == 'Canceled')) {
        cancelArr.push(item);
        flag = 3;
        return flag;
      }
      if (item.result && item.result.toLowerCase() != 'cancel') {
        allExCancelArr.push(item.result);
      }
      if (i == AllSources.length - 1) {
        if (!failArr.length) {//如果失败任务为null

          if (allResult.length == AllSources.length && commonUtils.isAllEqual(allResult) && allResult[0] == 'success') {
            flag = 2;//所有任务成功则是成功
          }
          if (!flag && successArr.length && ((successArr.length / allResult.length) * 100) < 80) {
            flag = 0;//如果成功任务小于80%就是失败
          }

        } else {
          //如果只有两个子任务，其中失败了一个则显示部分成功
          if ((((failArr.length / (allExCancelArr.length)) * 100) <= 20) || (allExCancelArr.length == 2 && failArr.length == 1)) {
            flag = 1; //错误任务不超过20%是部分成功
          } else if (failArr.length && (((failArr.length / (allExCancelArr.length)) * 100) > 20)) {
            flag = 0; //错误任务超过20%是失败
          }

        }

      }
    });
    return flag;
  },

};
let flag = true;



// WEBPACK FOOTER //
// ./src/js/workspace/task_list_util.js